/* eslint-disable camelcase */
import Layout from '../components/layout'
import {globalStylesProtection} from '../constants'
import {useExperiment} from '../experimentFramework/experiment'
import EXPERIMENT_CONFIG from '../experimentFramework/experimentConfigBrowser.json'

import BrowserV1 from '../components/templates/browser-v1/BrowserV1'
import BrowserWaitlistV1 from '../components/templates/browser-v1/browser-waitlist/BrowserWaitlistV1'
import {isMac, isUnsupportedOS, isWindows, getUserAgent} from '../util/userAgent'
import UnSupported from '../components/templates/browser-v1/UnSupported'

const BrowserPage = ({languageCode = `en`}) => {
    let os = 'unsupported'
    if (isMac()) os = 'mac'
    if (isWindows()) os = 'windows'
    const {experiment: experimentId = `browser-v1`} = useExperiment(EXPERIMENT_CONFIG, os)
    if (isUnsupportedOS()) {
        return <UnSupported os={os} browser={getUserAgent()} experimentId={experimentId} />
    }
    return (
        <Layout globalStyles={globalStylesProtection}>
            <BrowserWaitlistV1
                os={os}
                browser={getUserAgent()}
                experimentId={experimentId}
                languageCode={languageCode}
            />
        </Layout>
    )
}

export default BrowserPage
